import PropTypes from 'prop-types'
import React from 'react'
import { components } from 'react-select'

import Icon from 'components/Icon'

import './DropdownIndicator.scss'

const DropdownIndicator = props => {
  const disabledClass = props.selectProps.isDisabled
    ? 'dropdown-indicator--disabled'
    : ''
  const focusedClass = props.selectProps.menuIsOpen
    ? 'dropdown-indicator--rotated'
    : ''
  const iconColor = props.selectProps.isWhite ? 'white' : 'black'

  return (
    <components.DropdownIndicator {...props}>
      <div style={{ paddingRight: `${props.selectProps.withRightIndent}px` }}>
        <div
          className={`select__dropdown-arrow ${focusedClass} ${disabledClass}`}
        >
          <Icon id="arrow_down" color={iconColor} />
        </div>
      </div>
    </components.DropdownIndicator>
  )
}

DropdownIndicator.propTypes = {
  isFocused: PropTypes.bool.isRequired,
  selectProps: PropTypes.shape({
    isDisabled: PropTypes.bool.isRequired,
    isWhite: PropTypes.bool.isRequired,
    menuIsOpen: PropTypes.bool.isRequired,
    withRightIndent: PropTypes.number,
  }),
}

export default DropdownIndicator
